<template>
  <div class="home">

    <WorkCover>
      <template slot="cover">
        <img class="bg-cover" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FBambuser_mock%202%402x.webp?alt=media&token=e90e3fe2-d044-4f4d-b280-4ec0047cb44c" alt="">
      </template>
    </WorkCover>

    <WorkHeader>
      <template slot="year">2019</template>
      <template slot="client">Bambuser</template>
      <template slot="type">
        <div>
          <div>Web Design</div>
          <div>App Design</div>
          <div>Design System</div>
        </div>
      </template>
      <template slot="website">
        <a href="https://bambuser.com" target="_blank">www.bambuser.com</a>
      </template>
      <template slot="desc">
        Bambuser is a SaaS company based in Stockholm that provides the world’s leading Live Video Shopping technology.
        <br><br>
        Bambuser’s solution drives sales, customer engagement, and site traffic and is a powerful research tool used by some of the biggest brands and retailers in the world.
        <br><br>
        MESH was responsible for setting up a new digital design system to serve all digital platforms of the service. This came with a complete redesign of its different apps and web.
      </template>
    </WorkHeader>

    <WorkBambuser/>
    
    <Index/>

    <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import WorkCover from '@/components/work/WorkCover.vue'
import WorkHeader from '@/components/work/WorkHeader.vue'
import WorkBambuser from '@/components/work/WorkBambuser.vue'
import LogoAni from '@/components/LogoAni.vue'
import Slideshow from '@/components/Slideshow.vue'
import Index from '@/components/Index.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Bambuser',
  components: {
    WorkCover,
    WorkHeader,
    LogoAni,
    Slideshow,
    Index,
    Footer,
    WorkBambuser
  }
}
</script>
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

</style>
